import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GeneralMasterComponent } from './Masters/general-master/general-master.component';
import { UserMasterComponent } from './Masters/user-master/user-master.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from './login/login/login.component';
import { SetPasswordComponent } from './login/set-password/set-password.component';
import { ForgotPasswordComponent } from './login/forgot-password/forgot-password.component';
import { DashboardComponent } from './dashboard/dashboard/dashboard.component';
import { GenerateNoticeComponent } from './notice/generate-notice/generate-notice.component';
import { NavCaseNoticeComponent } from './notice/nav-case-notice/nav-case-notice.component';
import { AddorgcontactComponent } from './Masters/addorgcontact/addorgcontact.component';
import { CompanyMasterComponent } from './Masters/company-master/company-master.component';
import { AddFactSheetComponent } from './notice/add-fact-sheet/add-fact-sheet.component';
import { AddContactComponent } from './notice/add-contact/add-contact.component';
import { AddFollowupComponent } from './notice/add-followup/add-followup.component';
import { NoticeDiaryComponent } from './notice/notice-diary/notice-diary.component';
import { ExpenseComponent } from './notice/expense/expense.component';
import { ModuleComponent } from './dashboard/module/module.component';
import { AddMastersComponent } from './Masters/add-masters/add-masters.component';
import { AddLibraryComponent } from './dashboard/add-library/add-library.component';
import { ViewExpenseComponent } from './dashboard/view-expense/view-expense.component';
import { ViewDiaryComponent } from './dashboard/view-diary/view-diary.component';
import { AddUserMastersComponent } from './Masters/add-user-masters/add-user-masters.component';
import { ViewLibraryComponent } from './dashboard/view-library/view-library.component';
import { VieworgcontactComponent } from './Masters/vieworgcontact/vieworgcontact.component';
import { ViewfilterComponent } from './filter/viewfilter/viewfilter.component';
import { CorporateDecisionComponent } from './corporate-decision/corporate-decision.component';
import { NavCorporatedecisionComponent } from './corporate-decision/nav-corporatedecision/nav-corporatedecision.component';
import { ReportListingComponent } from './Report/report-listing/report-listing.component';
import { ColumnSelectionComponent } from './Report/column-selection/column-selection.component';
import { CreateDecisionComponent } from './corporate-decision/create-decision/create-decision.component';
import { CreateNoticecaseComponent } from './notice/create-noticecase/create-noticecase.component';
import { UpdateDiaryComponent } from './notice/update-diary/update-diary.component';
import { fvcComponent } from './notice/fvc/fvc.component';
import { ImportDataComponent } from './dashboard/import-data/import-data.component';
import { NavCompanyComponent } from './Masters/nav-company/nav-company.component';
import { MasterPageComponent } from './master-page/master-page.component';
import { MasterPageModule } from './master-page/master-page.module';
import { CommunityProfileComponent } from './community-profile/community-profile.component';
import { EscalationComponent } from './alerts/escalation/escalation.component';
import { NotificationComponent } from './alerts/notification/notification.component';
import { EditorComponent } from './email-editor/editor/editor.component';
import { EvaluationStructureComponent } from './evaluation/evaluation-structure/evaluation-structure.component';
import { NavEvaluationComponent } from './evaluation/nav-evaluation/nav-evaluation.component';
import { EvaluationFormComponent } from './evaluation/evaluation-form/evaluation-form.component';
import { sharingoptionFormComponent } from './evaluation/sharingoption-form/sharingoption-form.component';
import { GraphSummaryComponent } from './dashboard/graph-summary/graph-summary.component';
import { NotificationV2Component } from './alerts/notification-v2/notification-v2.component';
import { NotificationEntryComponent } from './alerts/notification-entry/notification-entry.component';
import { FeatureEntryComponent } from './alerts/feature-entry/feature-entry.component';
import { EscalationNavComponent } from './alerts/escalation-nav/escalation-nav.component';
import { EscalationUserEntryComponent } from './alerts/escalation-user-entry/escalation-user-entry.component';
import { EscalationReportEntryComponent } from './alerts/escalation-report-entry/escalation-report-entry.component';
import { RolePoliciesComponent } from './role-policy/role-policies/role-policies.component';
import { CaptionSettingsComponent } from './caption-setting/caption-settings/caption-settings.component';
import { SystemConfigurationComponent } from './system-configuration/system-configuration.component';
import { CaseTransferComponent } from './notice/case-transfer/case-transfer.component';
import { MyprofileComponent } from './dashboard/myprofile/myprofile.component';
import { ReportConfigurationComponent } from './Report/report-configuration/report-configuration.component';
import { ReportConfigNavComponent } from './Report/report-config-nav/report-config-nav.component';
import { AlertComponent } from './alertpopup/_alert/alert.component';
import { EmailLogComponent } from './alerts/email-log/email-log.component';
import { EcodeComponent } from './dashboard/Ecode/Ecode.component';

import { FinalVerdict, FinalVerdictComponent } from './notice/Final-Verdict/Final-Verdict.component';
const routes: Routes = [
// { path: '', redirectTo: '/', pathMatch: 'full' },

{ path: 'alert', component: AlertComponent },
{ path: 'masterpage', component: MasterPageComponent },
{ path: 'dashboard', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: DashboardComponent } ]
},
{ path: 'emaillog', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: EmailLogComponent } ]
},
{ path: 'configreport', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: ReportConfigNavComponent } ]
},
{ path: 'configurereport/:reportid/:id', component: MasterPageComponent,
children: [ { outlet: 'masterpage', path: '', component: ReportConfigurationComponent } ]
},
{ path: 'decision/:id', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: CreateDecisionComponent } ]
},
{ path: 'plan/:plan/:id', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: NavCorporatedecisionComponent } ]
},
{ path: 'corporate-decision/:decision-id', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: CorporateDecisionComponent } ]
},
{ path: 'import/:ProfileId', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: ImportDataComponent } ]
},
{ path: 'notice/:type/:id', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: CreateNoticecaseComponent } ]
},
{ path: 'nav/:notice/:id/:type', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: NavCaseNoticeComponent } ]
},
{ path: 'gnotice/:notice/:id', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: GenerateNoticeComponent } ]
},
{ path: 'viewexpense', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: ViewExpenseComponent } ]
},
{ path: 'viewdiary', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: ViewDiaryComponent } ]
},
{ path: 'Evaluation', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: NavEvaluationComponent } ]
},


{ path: 'viewlibrary', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: ViewLibraryComponent } ]
},

{ path: 'Ecode', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: EcodeComponent } ]
},

{ path: 'FinalVerdict', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: FinalVerdictComponent } ]
},


{ path: 'user-master', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: UserMasterComponent } ]
},
{ path: 'navcompany/:company/:id', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: NavCompanyComponent } ]
},
{ path: 'company-master/:contact/:id', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: CompanyMasterComponent } ]
},
{ path: 'general-master/:id', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: GeneralMasterComponent } ]
},
{ path: 'report/:Reportid/:Level/:ColID/:Filter/:Route/:Param', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: ReportListingComponent } ]
},
{ path: 'navorgcon/:contorg/:id', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component:  VieworgcontactComponent } ]
},
{ path: 'addorgcontact/:contact/:id', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: AddorgcontactComponent } ]
},
{ path: 'escalation', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: EscalationNavComponent } ]
},
{ path: 'notification', component: MasterPageComponent,
    // children: [ { outlet: 'masterpage', path: '', component: NotificationComponent } ]
    children: [ { outlet: 'masterpage', path: '', component: NotificationV2Component } ]
},
{ path: 'editor/:id', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: EditorComponent } ]
},
{ path: 'graph', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: GraphSummaryComponent } ]
},
{ path: 'system', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: SystemConfigurationComponent } ]
},
{ path: 'casetransfer/case/:id', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: CaseTransferComponent } ]
},
{
    path: 'FinalVerdict/:id/:random', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: FinalVerdictComponent } ]
},
{
    path: 'udc/:ucid/:cid/:random', component: MasterPageComponent,
    children: [ { outlet: 'masterpage', path: '', component: UpdateDiaryComponent } ]   
},
// { path: 'udc/:ucid/:cid/:random', component: UpdateDiaryComponent},
// { path: 'FinalVerdict/:id/:random', component: FinalVerdictComponent},
// { path: 'childworkcomp', component: ChildworkComponent },CaseTransferComponent
// { path: 'escalation', component: EscalationComponent },
{ path: '', component: LoginComponent },
{ path: 'rule', component: RolePoliciesComponent },
{ path: 'caption', component: CaptionSettingsComponent},
{ path: 'evalentry/:ncdid/:cid', component: EvaluationFormComponent },
{ path: 'sharingoption/:ncdid/:cid', component: sharingoptionFormComponent},

{ path: 'evaluationform/:id', component: EvaluationStructureComponent },
{ path: 'community', component: CommunityProfileComponent },
{ path: 'login', component: LoginComponent },
{ path: 'setpassword/:id', component: SetPasswordComponent },
{ path: 'forgotpassword', component: ForgotPasswordComponent },
{ path: 'afsc/:ncid/:cid/:random', component: AddFactSheetComponent},
{ path: 'acc/:ncid/:cid/:random', component: AddContactComponent},
{ path: 'afuc/:ncid/:cid/:random', component: AddFollowupComponent},
{ path: 'ndc/:ncid/:cid/:random', component: NoticeDiaryComponent},
{ path: 'fvc/:ucid/:cid/:random', component: fvcComponent},

{ path: 'module/:ncid', component: ModuleComponent},
{ path: 'expense/:ncid/:eid/:random', component: ExpenseComponent},
{ path: 'addlibrary/:eid', component: AddLibraryComponent},
{ path: 'add-masters/:mid/:randomno', component: AddMastersComponent},
{ path: 'filter/:Rid', component: ViewfilterComponent},
{ path: 'report/:Reportid', redirectTo: 'report/:Reportid/0/0/0/0/0'},
{ path: 'reportcolumn/:Reportid/:Type/:ReportConfig', component: ColumnSelectionComponent},
{ path: 'add-user-master/:uid', component: AddUserMastersComponent},
{ path: 'profile/:uid', component: MyprofileComponent},
{ path: 'notification-entry/:userdataid/:id/:ModuleID', component: NotificationEntryComponent},
{ path: 'feature-entry/:id', component: FeatureEntryComponent},
{ path: 'escalation-user-entry/:reportid/:userid', component: EscalationUserEntryComponent},
{ path: 'escalation-report-entry/:reportid', component: EscalationReportEntryComponent},
{ path: 'print-report/:Reportid/:Level/:ColID/:Filter/:Route/:Param', component: ReportListingComponent}
];

@NgModule({
  imports: [MasterPageModule, RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
